// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31fuJ","colBig":"styles_colBig__4YWm9","colSmall":"styles_colSmall__2ET-T","shopifyNameWrapper":"styles_shopifyNameWrapper__10hVC"};